// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum SourceType {
  Eshop = "ESHOP",
  Kiosk = "KIOSK",
  Salespoint = "SALESPOINT",
  ExternalDistribution = "EXTERNAL_DISTRIBUTION",
}
export default SourceType;
